export default __webpack_public_path__ + "static/simple-histogram-18d2825b9baa73a356351523db98f925.png";